<template>
	<div v-if="getUnpaid" class="hmt-payment-link" ref="root">
		<div class="hmt-payment-link-container">
			<span v-if="!getPaymentLink" class="hmt-payment-link-blank">
				Please contact your photographer to unlock the tour
			</span>
			<a class="hmt-payment-link-button" v-else :href="getPaymentLink">
				<span>&raquo;</span> Please click here to pay for the tour <span>&laquo;</span></a>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	export default {
		name: 'HMTPaymentLink',
		computed: {
			...mapGetters('tour', ['getUnpaid', 'getPaymentLink'])
		},
		methods: {
			disableRightClick (event) {
				event.preventDefault();
			},
			disableApp () {
				this.$refs.root.nextElementSibling.setAttribute('style', 'pointer-events: none; filter: grayscale(1);');
			}
		},
		mounted () {
			if(this.getUnpaid) {
				this.disableApp();
				window.addEventListener('contextmenu', this.disableRightClick, false);
			}
		},
		destroyed () {
			window.removeEventListener('contextmenu', this.disableRightClick);
		}
	}
</script>

<style lang="scss">
	.hmt-payment-link {
		&-container {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 65px;
			width: 100%;
			padding: 0 15px;
			background-color: #ef5450;
			text-align: center;
			box-shadow: 0 2px 2px rgba(0,0,0,.2);
		}

		&-blank {
			text-transform: uppercase;
			color: #fff;
		}

		&-button {
			display: block;
			text-transform: uppercase;
			font-size: 18px;
			color: #fff;
			letter-spacing: 0.03rem;

			&:hover {
				text-decoration: underline;
				color: #fff;
			}

			span {
				animation: blinking 1s infinite;
			}
		}
	}
</style>
